import { useEffect, useState } from "react";
import { useCommunication } from "../lib/CommunicationWrapper";

export enum LinkType {
    NOTE = "note",
    ASSIGNMENT = "assignment",
    FILE = "file",
    EXTERNAL = "external"
}

export interface Link {
    title: string,
    target: string;
    type: LinkType;
}

export function getLinkTargets(linkGroups: LinkGroup[]): any {
    const optimized: any = {
        [LinkType.ASSIGNMENT]: {},
        [LinkType.NOTE]: {},
        [LinkType.FILE]: {},
        [LinkType.EXTERNAL]: {}
    };

    linkGroups.forEach((group: LinkGroup) => {
        const [link1, link2] = group;
        
        // Add bidirectional links
        if (!optimized[link1.type][link1.target]) {
            optimized[link1.type][link1.target] = [];
        }
        optimized[link1.type][link1.target].push(link2);

        if (!optimized[link2.type][link2.target]) {
            optimized[link2.type][link2.target] = [];
        }
        optimized[link2.type][link2.target].push(link1);
    });

    return optimized;
}

export const combineCustomAssignments = (options: any) => {
    let output: any[] = [];
    for (const overflow of options?.["custom_assignments_overflow"] || []) {
        const customAssignments = options?.[overflow] || [];
        output = output.concat(customAssignments || []);
    }
    return output;
}

export const useCustomAssignments = () => {
    const { useRerenderListener } = useCommunication();
    const { options, trigger } = useRerenderListener(["custom_assignments_overflow", "custom_assignments_(.*)"]);

    const [customAssignments, setCustomAssignments] = useState<any[]>(() => combineCustomAssignments(options));


    useEffect(() => {
        const output = combineCustomAssignments(options);
        setCustomAssignments(output);
    }, [trigger]);

    return customAssignments;
}

export const useOverrides = () => {
    const { useRerenderListener } = useCommunication();
    const { options, trigger } = useRerenderListener(["overrides"]);
    const [overrides, setOverrides] = useState<any>(options["overrides"] || {});
    useEffect(() => {
        setOverrides(options?.["overrides"] || {});
    }, [trigger]);
    return overrides;
}

export const useLinks = () => {
    const { useRerenderListener } = useCommunication();
    const { options, trigger } = useRerenderListener(["links"]);
    const [links, setLinks] = useState<any>(getLinkTargets(options?.["links"] || []));
    useEffect(() => {
        setLinks(getLinkTargets(options?.["links"] || []));
    }, [trigger]);
    return links;
}